import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import HotRanking from "./components/HotRanking";
import CategorySection from "./components/CategorySection";
import LatestFeed from "./components/LatestFeed";
import VoiceSection from "./components/VoiceSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: siteInfo.name,
      url: "https://leiysp.cn/",
      description: siteInfo.tagline,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target:
          "https://leiysp.cn/topics?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  useSeo({
    title: "黑料专区 - 吃瓜讨论与热门话题社区",
    description:
      "黑料专区聚焦吃瓜讨论与热门话题，汇聚吃瓜热议、瓜友交流与观点碰撞，每日更新热议榜单，帮你快速看清大家都在聊什么。",
    keywords: "黑料专区,吃瓜讨论,吃瓜话题,瓜友讨论,吃瓜热议,吃瓜交流",
    path: "/",
    ogType: "website",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <HotRanking />
        <CategorySection />
        <LatestFeed />
        <VoiceSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}